export default __webpack_public_path__ + "img/6c0cf6cec1b19b73eea89fc44dd23dc3.svg";